import { fetchTopSellingClasses } from '../../api/topSellingApi'
import { ourClassesActions } from './ourClassesSlice'

export const getUpcomingClasses = () => async dispatch => {
    dispatch(ourClassesActions.getOurClasses())
    try {
        const courses = await fetchTopSellingClasses()
        dispatch(ourClassesActions.getOurClassesSuccess(courses))
    } catch (e) {
        dispatch(ourClassesActions.getOurClassesError(e.message))
    }
}
